/**
 * UUID v4。不用 crypto.randomUUID——iOS Safari 15.4 才有，支持范围要求 14+。
 * crypto.getRandomValues 全目标浏览器可用（主线程与 Worker 同源实现，Device-ID 与
 * 消息 clientId（任务 10）共用这一个）。
 */
export function uuidV4(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // RFC 4122：version 位=4，variant 位=10xx
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex: string[] = [];
  for (const b of bytes) hex.push(b.toString(16).padStart(2, '0'));
  return (
    hex.slice(0, 4).join('') +
    '-' +
    hex.slice(4, 6).join('') +
    '-' +
    hex.slice(6, 8).join('') +
    '-' +
    hex.slice(8, 10).join('') +
    '-' +
    hex.slice(10, 16).join('')
  );
}
